/*!

=========================================================
* Black Dashboard React v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useRef, useState } from 'react';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import {
  Checkbox,
  ListItemText,
  MenuItem,
  Select,
  Input as MInput,
  // withStyles,
  Menu,
  styled,
} from '@mui/material';
import BackupIcon from '@mui/icons-material/Backup';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ViewStudent from './ViewStudent';
//import { Modal } from '@mui/icons-material/';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  Input,
  UncontrolledDropdown,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { Edit, Delete, Add, Tune } from '@mui/icons-material';
import GetAppIcon from '@mui/icons-material/GetApp';
import FilterListIcon from '@mui/icons-material/FilterList';
import SortIcon from '@mui/icons-material/Sort';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton } from '@mui/material';
import KeyboardArrowLeftSharpIcon from '@mui/icons-material/KeyboardArrowLeftSharp';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';

import Add_Student from './student_add_and_edit_form';
import { db } from '../MY_LOGIN_AND_SIGNUP/db/config';
import Edit_Student from './Student_Edit._Form';
import Delete_modal from './Delete_Modal';
import NotificationAlert from 'react-notification-alert';
import firebase, { auth } from 'firebase';

import { CSVLink } from 'react-csv';

import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import AddMaterialStudent from './AddMaterialStudent';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import algoliasearch from 'algoliasearch/lite';
import { algoliaAppID, algoliaSearchID } from '../Utilities/algoliaKeys';
import DeleteSelected from 'components/NotificationCenter/DeleteSelected';
import StudentInBulk from './StudentInBulk';
import { JSONToCSVConvertor } from 'Utilities/downloadCSVFunction';
import IncompleteStudents from './IncompleteStudents';

const functions = firebase.functions();

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const StyledMenu = styled(Menu)(({ theme }) => ({
  paper: {
    border: '1px solid #d3d4d5',
  },
  elevation: 0,
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
}));

// StyledMenuItem using MUI's `styled` utility
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  '&:focus': {
    backgroundColor: theme.palette.primary.main,
    '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
      color: theme.palette.common.white,
    },
  },
}));

// const StyledMenu = withStyles({
//   paper: {
//     border: '1px solid #d3d4d5',
//   },
// })((props) => (
//   <Menu
//     elevation={0}
//     getContentAnchorEl={null}
//     anchorOrigin={{
//       vertical: 'bottom',
//       horizontal: 'center',
//     }}
//     transformOrigin={{
//       vertical: 'top',
//       horizontal: 'center',
//     }}
//     {...props}
//   />
// ));

// const StyledMenuItem = withStyles((theme) => ({
//   root: {
//     '&:focus': {
//       backgroundColor: theme.palette.primary.main,
//       '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
//         color: theme.palette.common.white,
//       },
//     },
//   },
// }))(MenuItem);

const shiftChooser = (shift) => {
  switch (shift) {
    case 'morningShift':
      return 'Morning Shift';
    case 'Morning':
      return 'Morning Shift';
    case 'eveningShift':
      return 'Evening Shift';
    case 'Evening':
      return 'Evening Shift';
    case 'afternoonShift':
      return 'Afternoon Shift';
    case 'Afternoon':
      return 'Afternoon Shift';
    default:
      break;
  }
};

function Students_Table() {
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? '#272a3d' : 'black',
      padding: 10,
    }),
    control: () => ({
      display: 'none',
    }),
  };
  const [limit, setLimit] = useState(10);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElSort, setAnchorElSort] = React.useState(null);
  const [viewUser, setViewUser] = React.useState([]);
  const [packageInfo, setPackageInfo] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickSort = (event) => {
    setAnchorElSort(event.currentTarget);
  };

  const handleClose = () => {
    setFilter(0);
    setAnchorEl(null);
  };

  const handleCloseSort = () => {
    setFilter(0);
    setAnchorElSort(null);
  };

  const [isBulkUpload, setIsBulkUpload] = useState(false);
  const [progressVisible, setProgressVisible] = useState(true);
  const [progressValue, setProgressValue] = useState(8);
  const [userData, setUserData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [inCompleteData, setInCompleteData] = useState(true);
  const [editVisible, setEditVisible] = useState(false);
  // const [enroll, setEnroll] = useState(null)
  const [editUser, setEditUser] = useState();
  const [deleteUserVisible, setDeleteUserVisible] = useState(false);
  const [deletedUser, setDeletedUser] = useState();

  const [batchList, setBatchList] = useState([]);
  const [startIndex, setStartIndex] = useState(1);
  const [endIndex, setEndIndex] = useState(0);
  const [filter, setFilter] = useState(0);
  const [fullDialogOpen, setFullDialogOpen] = useState(false);
  const [currentStuId, setcurrentStuId] = useState('');
  const searchClient = algoliasearch(algoliaAppID, algoliaSearchID);
  const studentSearchIndex = searchClient.initIndex('Student_Search');
  const [studentSearchValue, setStudentSearchValue] = useState('');
  const [csvData, setCsvData] = useState([]);
  const [csvData2, setCsvData2] = useState([]);
  const [search, setSearch] = useState(false);
  const [sortByErollment, setSortByErollment] = useState(false);
  const [allChecked, setAllChecked] = useState(false);
  const [isAllDeleteModalVisible, setIsAllDeleteModalVisible] = useState(false);
  const [viewVisible, setViewVisible] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [selected, setSelected] = useState(false);
  const [selectedArr, setSelectedArr] = useState([]);
  const [packages, setPackages] = useState([]);

  const [selectedbranch, setSelectedBranch] = useState('');

  const handlefullToggle = () => {
    setFullDialogOpen((prev) => !prev);
  };
  // const headers = [
  //   { label: "Enrollment No.", key: "enrollment" },
  //   { label: "Name", key: "name" },
  //   { label: "Email", key: "email" },
  //   { label: "Mobile No.", key: "mobile" },
  //   { label: "Address", key: "address" },
  //   { label: "Batch", key: "batch" },
  //   { label: "Shift", key: "shift" },
  //   { label: "Status", key: "status" },

  // ];

  const headers = [
    { label: 'Firstname', key: 'firstname' },
    { label: 'Lastname', key: 'lastname' },
    { label: 'Mobile', key: 'mobile' },
    { label: 'Whatsapp No', key: 'whatsapp' },
    { label: 'Email', key: 'email' },
    // { label: "Password", key: "password" },
    { label: 'Enrollment NO', key: 'enrollmentNO' },
    { label: "Father's Name", key: 'fatherName' },
    { label: "Mother's Name", key: 'motherName' },
    { label: 'gender', key: 'gender' },
    { label: "Husband's Name", key: 'husbandName' },
    { label: "Father/Guardian's Occupation", key: 'fatherGuardianOccupation' },
    { label: 'Address', key: 'address' },
    { label: 'AddresspinCode', key: 'addresspinCode' },
    { label: 'DateofBirth', key: 'dateofBirth' },
    { label: 'Category', key: 'category' },
    { label: 'Courses', key: 'Courses' },
    { label: 'Educational Qualification', key: 'educationalQualification' },
    {
      label: 'Educational Qualification Passing Year',
      key: 'educationalQualificationPassingYear',
    },
    { label: 'Professional Qualification', key: 'professionalQualification' },
    {
      label: 'Professional Qualification Passing Year',
      key: 'professionalQualificationPassingYear',
    },
    { label: 'Marks of CTET', key: 'marksofCTET' },
    { label: 'Secondary Email', key: 'secondaryEmail' },
    { label: 'Status', key: 'status' },
  ];

  const notifi = useRef();
  const notify = (msg, err) => {
    // console.log('notify')
    let color = err == false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err == false ? 'Success' : 'Error'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
    // notification(options);
  };

  const studentSearch = () => {
    if (studentSearchValue == '') {
      notify('Search field can not be empty', true);
    } else if (studentSearchValue.length <= 3) {
      notify('Search atleast 4 words', true);
    } else {
      setSearch(true);
      document.querySelector('#loading-indicator').style.display = 'flex';

      studentSearchIndex
        .search(studentSearchValue, { typoTolerance: false })
        .then((result) => {
          if (result.hits.length === 0) {
            document.querySelector('#loading-indicator').style.display = 'none';
            notify('No results found', true);
          } else {
            const filterData = result.hits;
            console.log(result.hits, 'result');
            document.querySelector('#loading-indicator').style.display = 'none';
            if (filterData.length == 0) return notify('No results found', true);
            setUserData(filterData);
            // downloadUserData(result.hits);
          }
        })
        .catch((err) => {
          document.querySelector('#loading-indicator').style.display = 'none';
          notify(err.toString(), true);
        });
    }
  };

  const getUsers = (orderBy) => {
    setProgressValue(99);
    document.querySelector('#loading-indicator').style.display = 'flex';
    if (orderBy) {
      db.collection('zSystemStudents')
        // .where('enrollmentNO', 'not-in', ['undefined', ''])
        .orderBy('enrollmentNO', orderBy)
        .limit(limit)
        .get()
        .then(function (querySnapshot) {
          var students = [];
          querySnapshot.docs.forEach(function (doc) {
            students.push(doc.data());
          });

          document.querySelector('#loading-indicator').style.display = 'none';
          // downloadUserData()
          setUserData(students);
          setProgressVisible(false);
          setStartIndex(1);
          setEndIndex(students.length);
        });
      return;
    }

    db.collection('zSystemStudents')
      .orderBy('createdAt', 'desc')
      .limit(limit)
      .get()
      .then(function (querySnapshot) {
        var students = [];
        querySnapshot.docs.forEach(function (doc) {
          students.push(doc.data());
        });
        students = students.map((item) => {
          return { ...item, select: false };
        });
        document.querySelector('#loading-indicator').style.display = 'none';
        // downloadUserData()
        setUserData(students);
        setProgressVisible(false);
        setStartIndex(1);
        setEndIndex(students.length);
      });
  };

  const getBatch = () => {
    db.collection('Batch')
      .where('type', '==', 'batch')
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => doc.data());
        setBatchList(data);
      });
  };

  const getCurrentUser = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        db.collection('zSystemUsers')
          .doc(user.uid)
          .get()
          .then((query) => {
            let data = query.data();
            console.log('currentuserData', data);
            setCurrentUser(data);
          });
      }
    });
  };

  // useEffect(()=>{
  //   if(csvData.length !== 0 && packages.length !== 0 ) {
  //     console.log('run')
  //     setCsvData2(() => csvData.map(item => item.Courses ?
  //       {...item,
  //         educationalQualificationPassingYear: item?.educationalQualificationPassingYear?.seconds !== undefined ? new Date(item.educationalQualificationPassingYear.seconds * 1000).getFullYear() : item.educationalQualificationPassingYear,
  //         professionalQualificationPassingYear: item?.professionalQualificationPassingYear?.seconds !== undefined ? new Date(item.professionalQualificationPassingYear.seconds * 1000).getFullYear() : item.professionalQualificationPassingYear,
  //         Courses: item.Courses.map(item2 => packages.find(fitem=>fitem.itemID === item2)?.title)
  //       } : {...item,
  //         educationalQualificationPassingYear: item?.educationalQualificationPassingYear?.seconds !== undefined? new Date(item.educationalQualificationPassingYear.seconds * 1000).getFullYear() : item.educationalQualificationPassingYear,
  //         professionalQualificationPassingYear: item?.professionalQualificationPassingYear?.seconds !== undefined ? new Date(item.professionalQualificationPassingYear.seconds * 1000).getFullYear() : item.professionalQualificationPassingYear,

  //       }))
  //   }
  // },[packages,csvData])

  useEffect(() => {
    getBatch();
    getPackages();
    getCurrentUser();
  }, []);

  useEffect(() => {
    if (sortByErollment) {
      getUsers(sortByErollment);
      return;
    }
    getUsers();
  }, [limit]);

  useEffect(() => {
    if (viewVisible && !packageInfo) {
      db.collection('zSystemStore')
        .get()
        .then((querySnapshot) => {
          let data = querySnapshot.docs.map((doc) => doc.data());
          let finalData = {};
          data = data.map((item) => ({
            itemID: [item.itemID],
            title: item?.title,
          }));
          for (var i = 0; i < data.length; i++) {
            finalData[data[i].itemID] = data[i].title;
          }
          setPackageInfo(finalData);
        });
    }
  }, [viewVisible]);

  const filterSearch = (data) => {
    console.log(data);
    document.querySelector('#loading-indicator').style.display = 'flex';

    db.collection('zSystemStudents')
      .where('status', '==', data)
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => doc.data());
        // doc.data() is never undefined for query doc snapshots
        document.querySelector('#loading-indicator').style.display = 'none';

        setUserData(data);
        // downloadUserData(data);
        console.log(' => ', data);
      })
      .catch((err) => {
        document.querySelector('#loading-indicator').style.display = 'none';
        notify(err.toString(), true);
        console.log(err.toString());
      });
  };

  const filterBatchSearch = (data) => {
    console.log('batch', data);
    document.querySelector('#loading-indicator').style.display = 'flex';

    db.collection('zSystemStudents')
      .where('batch', 'array-contains', data)
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => doc.data());
        console.log('data', querySnapshot);
        document.querySelector('#loading-indicator').style.display = 'none';
        setUserData(data);
        // downloadUserData(data);
      })
      .catch((err) => {
        document.querySelector('#loading-indicator').style.display = 'none';
        notify(err.toString(), true);
        console.log(err.toString());
      });
  };

  const nextSet = () => {
    // console.log(lastDoc)
    // if (userData.length === limit) {
    document.querySelector('#loading-indicator').style.display = 'flex';

    if (sortByErollment) {
      db.collection('zSystemStudents')
        .orderBy('enrollmentNO', sortByErollment)
        .where('enrollmentNO', 'not-in', ['undefined', ''])
        .startAfter(userData[userData.length - 1].enrollmentNO)
        .limit(limit)
        .get()
        .then((querySnapshot) => {
          let data = querySnapshot.docs.map((doc) => {
            return doc.data();
          });

          if (data.length !== 0) {
            document.querySelector('#loading-indicator').style.display = 'none';

            setUserData(data);
            // downloadUserData(data);
            setStartIndex(endIndex + 1);
            setEndIndex((prev) => prev + data.length);
          } else {
            document.querySelector('#loading-indicator').style.display = 'none';

            notify('End Of the list', true);
          }
        })
        .catch((err) => {
          if (document.querySelector('#loading-indicator'))
            document.querySelector('#loading-indicator').style.display = 'none';
          notify(err.toString(), true);
          console.log(err.toString());
        });
      return;
    }

    db.collection('zSystemStudents')
      .orderBy('createdAt', 'desc')
      .startAfter(userData[userData.length - 1].createdAt)
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => {
          return doc.data();
        });

        if (data.length !== 0) {
          document.querySelector('#loading-indicator').style.display = 'none';

          setUserData(data);
          // downloadUserData(data);
          setStartIndex(endIndex + 1);
          setEndIndex((prev) => prev + data.length);
        } else {
          document.querySelector('#loading-indicator').style.display = 'none';

          notify('End Of the list', true);
        }
      })
      .catch((err) => {
        if (document.querySelector('#loading-indicator'))
          document.querySelector('#loading-indicator').style.display = 'none';
        notify(err.toString(), true);
        console.log(err.toString());
      });
  };

  const prevSet = async () => {
    document.querySelector('#loading-indicator').style.display = 'flex';
    let querySnapshot = {};
    if (sortByErollment) {
      querySnapshot = await db
        .collection('zSystemStudents')
        .orderBy('enrollmentNO', sortByErollment === 'asc' ? 'desc' : 'asc')
        .startAfter(userData[0].enrollmentNO)
        .limit(limit)
        .get()
        .catch((err) => {
          document.querySelector('#loading-indicator').style.display = 'none';
          notify(err.toString(), true);
          console.log(err.toString());
        });
    } else {
      querySnapshot = await db
        .collection('zSystemStudents')
        .orderBy('createdAt')
        .startAfter(userData[0].createdAt)
        .limit(limit)
        .get()
        .catch((err) => {
          document.querySelector('#loading-indicator').style.display = 'none';
          notify(err.toString(), true);
          console.log(err.toString());
        });
    }
    // .endBefore(quizData[0].questionTitle).get()
    // .then(
    // querySnapshot => {
    let data = querySnapshot.docs.map((doc) => {
      return doc.data();
    });
    if (data.length !== 0) {
      document.querySelector('#loading-indicator').style.display = 'none';

      data = data.reverse();

      setStartIndex((prev) => prev - data.length);
      setEndIndex((prev) => prev - userData.length);
      setUserData(data);
      console.log('my user data is ', data);
    } else {
      document.querySelector('#loading-indicator').style.display = 'none';

      console.log('Can not go back');
    }
    // })
  };

  const batchDataUpdate = (newBatch, action, id, batchName) => {
    const batch = db.batch();
    if (action === 'select-option') {
      batch.set(
        db.collection('zSystemStudents').doc(id),
        {
          batch: firebase.firestore.FieldValue.arrayUnion(newBatch),
          batchName: batchName,
        },
        { merge: true }
      );
      batch.set(
        db.collection('Batch').doc(newBatch),
        { enrolledStudent: firebase.firestore.FieldValue.increment(1) },
        { merge: true }
      );
    } else if (action === 'deselect-option') {
      batch.set(
        db.collection('zSystemStudents').doc(id),
        {
          batch: firebase.firestore.FieldValue.arrayRemove(newBatch),
          batchName: batchName,
        },
        { merge: true }
      );
      batch.set(
        db.collection('Batch').doc(newBatch),
        { enrolledStudent: firebase.firestore.FieldValue.increment(-1) },
        { merge: true }
      );
    }
    batch
      .commit()
      .then((res) => {
        setUserData((prev) =>
          prev.map((item) => {
            if (item._uniqueID == id) {
              return {
                ...item,
                batchName: batchName ? batchName : [],
              };
            }
            return item;
          })
        );
        document.querySelector('#loading-indicator').style.display = 'none';
      })
      .catch((err) => {
        document.querySelector('#loading-indicator').style.display = 'none';
        console.log('err', err);
      });
  };

  const batchSelect = (newBatch, action, id, batchName) => {
    if (action === 'select-option') {
      db.collection('Batch')
        .where('itemID', '==', newBatch)
        .get()
        .then((querySnapshot) => {
          let data = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          if (
            data[0].enrolledStudent &&
            data[0].enrolledStudent > data[0].maxStudent
          ) {
            notify('Batch is full', true);
            document.querySelector('#loading-indicator').style.display = 'none';
          } else {
            batchDataUpdate(newBatch, action, id, batchName);
          }
          // data[0].enrolledStudent ? data[0].enrolledStudent < data[0].maxStudent ?
          // batchDataUpdate(newBatch, action, id, batchName) : notify("Batch is full", true)
          // : batchDataUpdate(newBatch, action,id, batchName)
        })
        .catch((err) => {
          console.log('err in batch', err);
          notify('Something went wrong', true);
          if (document.querySelector('#loading-indicator'))
            document.querySelector('#loading-indicator').style.display = 'none';
        });
    } else if (action === 'deselect-option') {
      batchDataUpdate(newBatch, action, id, batchName);
    }
  };

  const emptyStudent = () => {
    getUsers();
  };

  const getPackages = () => {
    db.collection('zSystemStore')
      .where('type', '==', 'package')
      .where('withClasses', '==', true)
      .get()
      .then((query) => {
        let data = query.docs.map((doc) => doc.data());
        setPackages(data);
      });
  };

  const downloadUserData = (data) => {
    if (data) {
      // let userDataArr = data.map(student => {
      //   return ({
      //     enrollment: student.enrollmentNO ? student.enrollmentNO : "N/A",
      //     name: `${student.firstname} ${student.lastname}`,
      //     email: student.email ? student.email : "N/A",
      //     mobile: student.mobile ? student.mobile : "N/A",
      //     address: student?.address ? student?.address : "N/A",
      //     batch: student?.batchName ? student?.batchName?.map(item => item?.label) : "N/A",
      //     shift: student?.shift ? student?.shift : "N/A",
      //     status: student?.status ? student?.status : "N/A",
      //   })
      // })

      setCsvData(data);
      return;
    } else {
      db.collection('zSystemStudents')
        .orderBy('createdAt', 'desc')
        .get()
        .then(function (querySnapshot) {
          var students = [];
          querySnapshot.docs.forEach(function (doc) {
            students.push(doc.data());
          });
          // let userDataArr = students.map(student => {
          //   return ({
          //     enrollment: student.enrollmentNO ? student.enrollmentNO : "N/A",
          //     name: `${student.firstname} ${student.lastname}`,
          //     email: student.email ? student.email : "N/A",
          //     mobile: student.mobile ? student.mobile : "N/A",
          //     address: student?.address ? student?.address : "N/A",
          //     batch: student?.batchName ? student?.batchName?.map(item => item?.label) : "N/A",
          //     shift: student?.shift ?  student?.shift : "N/A",
          //     status: student?.status ? student?.status : "N/A",
          //   })
          // })
          console.log(students);
          setCsvData(students);
          return;
        });
    }
  };

  const getDeleteUsers = () => {
    db.collection('zSystemStudents')
      .orderBy('createdAt', 'desc')
      .startAfter(userData[0]?.createdAt)
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => {
          return doc.data();
        });

        if (data.length !== 0) {
          document.querySelector('#loading-indicator').style.display = 'none';

          setUserData(data);
          // downloadUserData(data);
        } else {
          document.querySelector('#loading-indicator').style.display = 'none';

          notify('End Of the list', true);
        }
      })
      .catch((err) => {
        if (document.querySelector('#loading-indicator'))
          document.querySelector('#loading-indicator').style.display = 'none';
        notify(err.toString(), true);
        console.log(err.toString());
      });
  };

  const deleteSelectedStudents = () => {
    document.querySelector('#loading-indicator').style.display = 'flex';
    let selectedId = [];
    userData.map((item) => {
      if (item.select && item._uniqueID != undefined) {
        selectedId.push(item._uniqueID);
      }
    });
    console.log('id:', selectedId);

    const deleteMultipleStudents = functions.httpsCallable(
      'deleteMultipleStudents'
    );

    deleteMultipleStudents(selectedId)
      .then((result) => {
        // console.log('result', result)
        if (result.data.hasError === false) {
          document.querySelector('#loading-indicator').style.display = 'none';

          // setUserData(prev=>prev.filter(item => !selectedId.includes(item._uniqueID)))
          getDeleteUsers();
          setIsAllDeleteModalVisible(false);
          notify('Selected Students details deleted successfully', false);
        } else {
          document.querySelector('#loading-indicator').style.display = 'none';

          notify(result.data.message.errorInfo.message.toString(), true);
        }
      })
      .catch((err) => {
        notify(err.toString(), true);
        document.querySelector('#loading-indicator').style.display = 'none';
        console.log(err.toString());
      });

    // let batch = db.batch()
    // for (let i = 0; i < selectedId.length; i++) {

    //   batch.delete(db.collection('MediaCenter').doc(selectedId[i]))

    // }

    // batch.commit().then(() => {
    //   setMediaData(prev=>prev.filter(item => !selectedId.includes(item.itemID) ))
    //   setIsAllDeleteModalVisible(false);
    //   notify('Seleted items deleted successfully', false);
    // })
    // .catch(err=>{
    //   console.log(err);
    //   notify(err.message.toString(), false);
    // })
  };

  const downloadCSV = () => {
    document.querySelector('#loading-indicator').style.display = 'flex';
    db.collection('zSystemStudents')
      .orderBy('createdAt', 'desc')
      .get()
      .then(function (querySnapshot) {
        var students = [];
        querySnapshot.docs.forEach(function (doc) {
          let data = doc.data();
          students.push({
            enrollment: data.enrollmentNO ? data.enrollmentNO : 'N/A',
            name: data.firstname ? `${data.firstname} ${data.lastname}` : 'N/A',
            motherName: data.motherName ? data.motherName : 'N/A',
            fatherName: data.fatherName ? data.fatherName : 'N/A',
            fatherName: data.fatherGuardianOccupation
              ? data.fatherGuardianOccupation
              : 'N/A',
            husbandName: data.husbandName ? data.husbandName : ' ',
            gender: data.gender ? data.gender : 'N/A',
            email: data.email ? data.email : 'N/A',
            secondaryEmail: data.secondaryEmail ? data.secondaryEmail : 'N/A',
            mobile: data.mobile ? data.mobile : 'N/A',
            whatsapp: data.whatsapp ? data.whatsapp : 'N/A',
            address: data?.address ? data?.address : 'N/A',
            addresspinCode: data?.addresspinCode ? data?.addresspinCode : 'N/A',
            category: data?.category ? data?.category : 'N/A',
            dateofBirth: data?.dateofBirth ? data?.dateofBirth : 'N/A',
            batch: data?.batchName
              ? data?.batchName
                ? data?.batchName?.map((item) => item?.label)
                : 'N/A'
              : 'N/A',
            shift: data?.shift ? data?.shift : 'N/A',
            status: data?.status ? data?.status : 'N/A',
            educationalQualification: data?.educationalQualification
              ? data?.educationalQualification
              : 'N/A',
            educationalQualificationPassingYear:
              data?.educationalQualificationPassingYear
                ? data?.educationalQualificationPassingYear?.seconds !==
                  undefined
                  ? new Date(
                      data.educationalQualificationPassingYear.seconds * 1000
                    ).getFullYear()
                  : data.educationalQualificationPassingYear
                : 'N/A',
            professionalQualificationPassingYear:
              data?.professionalQualificationPassingYear
                ? data?.professionalQualificationPassingYear?.seconds !==
                  undefined
                  ? new Date(
                      data.professionalQualificationPassingYear.seconds * 1000
                    ).getFullYear()
                  : data.professionalQualificationPassingYear
                : 'N/A',
            Courses: data?.Courses
              ? data?.Courses?.map(
                  (item2) =>
                    packages.find((fitem) => fitem.itemID === item2)?.title
                )
              : 'N/A',
            marksofCTET: data.marksofCTET ? data.marksofCTET : 'N/A',
            status: data.status ? data.status : 'N/A',
          });
        });
        console.log('students:', students);
        JSONToCSVConvertor(
          students,
          `Students Info ${new Date().valueOf()}`,
          true
        );
        document.querySelector('#loading-indicator').style.display = 'none';
      })
      .catch((err) => {
        document.querySelector('#loading-indicator').style.display = 'none';
        console.log(err);
      });
  };

  console.log('currentUser', currentUser);

  return (
    <>
      {progressVisible ? (
        <Progress color='info' value={progressValue} style={{ height: 4 }} />
      ) : (
        <div className='content'>
          <div className='react-notification-alert-container'>
            <NotificationAlert ref={notifi} />
          </div>
          <Dialog
            fullScreen
            open={fullDialogOpen}
            onClose={handlefullToggle}
            TransitionComponent={Transition}
          >
            <AddMaterialStudent
              notifi={notify}
              currentStuId={currentStuId}
              handleClose={handlefullToggle}
            />
          </Dialog>
          <Row>
            <Col md='12'>
              <Card>
                <CardHeader
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                  }}
                >
                  <CardTitle
                    tag='h4'
                    style={{
                      marginRight: 'auto',
                      fontWeight: 300,
                      textAlign: 'left',
                    }}
                  >
                    STUDENT MANAGEMENT
                  </CardTitle>

                  {inCompleteData ? (
                    <Button
                      color='info'
                      style={{ marginRight: 25 }}
                      onClick={() =>
                        setInCompleteData(inCompleteData ? false : true)
                      }
                    >
                      Pending Accounts
                    </Button>
                  ) : (
                    <Button
                      color='info'
                      style={{ marginRight: 25 }}
                      onClick={() => {
                        setInCompleteData(inCompleteData ? false : true);
                        emptyStudent();
                      }}
                    >
                      Active Accounts
                    </Button>
                  )}

                  {inCompleteData ? (
                    <Button
                      color='info'
                      style={{ marginRight: 25 }}
                      onClick={() => setIsModalVisible(true)}
                    >
                      Create Student <Add />
                    </Button>
                  ) : (
                    ''
                  )}
                  {currentUser?.modificationAccess === '0' && (
                    <div>
                      {inCompleteData && (
                        <Button
                          style={{ padding: '7px 13px' }}
                          onClick={downloadCSV}
                        >
                          <GetAppIcon style={{ color: 'white' }} />
                        </Button>
                      )}
                    </div>
                  )}
                </CardHeader>
                <CardBody style={{ paddingTop: '10px' }}>
                  {inCompleteData ? (
                    <Row>
                      <Col sm={4}>
                        <Input
                          type='text'
                          name='search'
                          placeholder='Search Student'
                          onChange={(e) => (
                            setStudentSearchValue(e.target.value),
                            e.target.value.length === 0 && emptyStudent(),
                            setSearch(false)
                          )}
                        />
                      </Col>
                      <Col style={{ paddingLeft: '0px' }} sm={2}>
                        <Button
                          style={{ margin: '0px', padding: '6px 10px' }}
                          color='info'
                          onClick={studentSearch}
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                      <Col
                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                        sm={selected || selectedArr.length > 0 ? 5 : 6}
                      >
                        {!search && (
                          <>
                            <p
                              style={{
                                position: 'relative',
                                top: '8px',
                                marginRight: '15px',
                              }}
                            >
                              {startIndex <= 1 ? 1 : startIndex} - {endIndex}
                            </p>
                            <div style={{ position: 'relative', top: '-5px' }}>
                              {startIndex > 1 && (
                                <IconButton
                                  style={{ outline: 'none' }}
                                  onClick={() => {
                                    prevSet();
                                  }}
                                >
                                  <KeyboardArrowLeftSharpIcon
                                    style={{ color: 'white' }}
                                  />
                                </IconButton>
                              )}
                              <IconButton
                                style={{ outline: 'none' }}
                                onClick={() => nextSet()}
                              >
                                <KeyboardArrowRightSharpIcon
                                  style={{ color: 'white' }}
                                />
                              </IconButton>
                            </div>
                            <select
                              className='form-control'
                              style={{
                                maxWidth: 67,
                                marginRight: 10,
                                position: 'relative',
                                top: 3,
                              }}
                              type='select'
                              value={limit}
                              onChange={(e) =>
                                setLimit(parseInt(e.target.value))
                              }
                              // required
                            >
                              <option value='10'>10</option>
                              <option value='50'>50</option>
                              <option value='100'>100</option>
                            </select>
                            <div>
                              <Button
                                aria-controls='customized-menu'
                                aria-haspopup='true'
                                variant='contained'
                                style={{ padding: '6px 12px' }}
                                color='info'
                                onClick={handleClick}
                              >
                                <FilterListIcon />
                              </Button>
                              <StyledMenu
                                id='customized-menu'
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                              >
                                <StyledMenuItem>
                                  <ListItemText
                                    primary='Filter By Status'
                                    onClick={() => {
                                      setFilter(0);
                                    }}
                                  />
                                </StyledMenuItem>
                                <StyledMenuItem>
                                  <ListItemText
                                    primary='Filter By Batch'
                                    onClick={() => {
                                      setFilter(1);
                                    }}
                                  />
                                </StyledMenuItem>
                                {filter === 0 && (
                                  <>
                                    <StyledMenuItem>
                                      <ListItemText
                                        primary='All'
                                        onClick={() => {
                                          document.querySelector(
                                            '#loading-indicator'
                                          ).style.display = 'flex';
                                          getUsers();
                                          handleClose();
                                        }}
                                      />
                                    </StyledMenuItem>
                                    <StyledMenuItem>
                                      <ListItemText
                                        primary='Active'
                                        onClick={() => {
                                          filterSearch('Active');
                                          handleClose();
                                        }}
                                      />
                                    </StyledMenuItem>
                                    <StyledMenuItem>
                                      <ListItemText
                                        primary='Inactive'
                                        onClick={() => {
                                          filterSearch('Inactive');
                                          handleClose();
                                        }}
                                      />
                                    </StyledMenuItem>
                                  </>
                                )}
                                {filter === 1 && (
                                  <>
                                    <StyledMenuItem>
                                      <ListItemText
                                        primary='All'
                                        onClick={() => {
                                          getUsers();
                                          handleClose();
                                        }}
                                      />
                                    </StyledMenuItem>
                                    {batchList.map((item) => {
                                      return (
                                        <StyledMenuItem>
                                          <ListItemText
                                            primary={item.batchName}
                                            onClick={() => {
                                              filterBatchSearch(item.itemID);
                                              setSelectedBranch(item.batchName);
                                              handleClose();
                                            }}
                                          />
                                        </StyledMenuItem>
                                      );
                                    })}
                                  </>
                                )}
                              </StyledMenu>
                            </div>
                            <div>
                              <Button
                                aria-controls='customized-menu'
                                aria-haspopup='true'
                                variant='contained'
                                style={{ padding: '6px 12px', marginLeft: 5 }}
                                color='info'
                                onClick={handleClickSort}
                              >
                                <SortIcon />
                              </Button>
                              <StyledMenu
                                id='customized-menu'
                                anchorEl={anchorElSort}
                                keepMounted
                                open={Boolean(anchorElSort)}
                                onClose={handleCloseSort}
                              >
                                <StyledMenuItem>
                                  <ListItemText
                                    primary='Sort By Enrollment No'
                                    onClick={() => {
                                      setFilter(0);
                                    }}
                                  />
                                </StyledMenuItem>
                                {filter === 0 && (
                                  <>
                                    <StyledMenuItem>
                                      <ListItemText
                                        primary='Ascending'
                                        onClick={() => {
                                          setSortByErollment('asc');
                                          getUsers('asc');
                                          handleCloseSort();
                                        }}
                                      />
                                    </StyledMenuItem>
                                    <StyledMenuItem>
                                      <ListItemText
                                        primary='Descending'
                                        onClick={() => {
                                          setSortByErollment('desc');
                                          getUsers('desc');
                                          handleCloseSort();
                                        }}
                                      />
                                    </StyledMenuItem>
                                    {sortByErollment && (
                                      <StyledMenuItem>
                                        <ListItemText
                                          primary='Clear'
                                          onClick={() => {
                                            setSortByErollment('');
                                            getUsers();
                                            handleCloseSort();
                                          }}
                                        />
                                      </StyledMenuItem>
                                    )}
                                  </>
                                )}
                              </StyledMenu>
                            </div>
                          </>
                        )}
                      </Col>
                      {(currentUser?.modificationAccess == '0' && selected) ||
                      selectedArr.length > 0 ? (
                        <Col
                          style={{ paddingRight: '0px', marginTop: 4 }}
                          sm={1}
                        >
                          <Button
                            style={{ margin: '0px', padding: '6px 10px' }}
                            color='danger'
                            onClick={() => setIsAllDeleteModalVisible(true)}
                          >
                            <Delete />
                          </Button>
                        </Col>
                      ) : null}
                    </Row>
                  ) : (
                    ''
                  )}

                  <Dialog fullScreen open={isBulkUpload}>
                    {/* <MediaDialog notify={notify} currentData={currentData} handleClose={setIsModalVisible} setMediaData={setMediaData}  /> */}
                    <StudentInBulk setIsBulkUpload={setIsBulkUpload} />
                  </Dialog>
                  {/* <Modal isOpen={isBulkUpload} color='primary' style={{ display: 'flex', flex: 1, backgroundColor: '#132639', objectFit: 'fill' }} >
                    <StudentInBulk/>
                  </Modal>  */}
                  <Modal
                    isOpen={isAllDeleteModalVisible}
                    color='primary'
                    style={{
                      display: 'flex',
                      flex: 1,
                      top: -40,
                      width: 350,
                      backgroundColor: '#132639',
                      objectFit: 'fill',
                    }}
                  >
                    <ModalBody size='sm' style={{ textAlign: 'center' }}>
                      <DeleteSelected
                        setIsAllDeleteModalVisible={setIsAllDeleteModalVisible}
                        deleteSelected={deleteSelectedStudents}
                      />
                    </ModalBody>
                  </Modal>
                  <Modal
                    isOpen={isModalVisible}
                    style={{ display: 'flex', flex: 1 }}
                    size='lg'
                  >
                    <ModalBody
                      style={{
                        width: '100%',
                        display: 'inline-block',
                        padding: '0px !important',
                        position: 'absolute',
                        border: '1px solid white !important',
                      }}
                      size='sm'
                    >
                      <Add_Student
                        notify={notify}
                        setModal={(val) => setIsModalVisible(val)}
                        setUserData={setUserData}
                      ></Add_Student>
                    </ModalBody>
                  </Modal>
                  <Modal
                    isOpen={editVisible}
                    style={{ display: 'flex', flex: 1, top: 0 }}
                    size='lg'
                  >
                    <ModalBody
                      style={{
                        width: '100%',
                        display: 'inline-block',
                        padding: '0px !important',
                        position: 'absolute',
                        border: '1px solid white !important',
                      }}
                      size='sm'
                    >
                      <Edit_Student
                        notify={notify}
                        userData={editUser}
                        setUserData={setUserData}
                        // firstname={editUser!==undefined && editUser.firstname}
                        // lastname={editUser!==undefined&& editUser.lastname}
                        // mobile={editUser!==undefined &&editUser.mobile}
                        // status={editUser!==undefined &&editUser.status}
                        // enrollment={editUser!==undefined && editUser.enrollment}
                        onClick={() => {
                          setEditVisible(false);
                        }}
                      ></Edit_Student>
                    </ModalBody>
                  </Modal>
                  <Modal isOpen={deleteUserVisible} style={{ width: 250 }}>
                    <ModalBody style={{ width: '100%', padding: 0 }} size='sm'>
                      <Delete_modal
                        notify={notify}
                        setUserData={setUserData}
                        uid={deletedUser !== undefined && deletedUser._uniqueID}
                        onClick={() => {
                          setDeleteUserVisible(false);
                        }}
                        getUsers={getUsers}
                        userData={userData}
                      ></Delete_modal>
                    </ModalBody>
                  </Modal>
                  <Modal
                    isOpen={viewVisible}
                    style={{ top: 0, width: '100%', maxWidth: '70%' }}
                  >
                    <ModalBody
                      style={{
                        width: '100%',
                        display: 'inline-block',
                        padding: '0px !important',
                        position: 'absolute',
                        border: '1px solid white !important',
                      }}
                    >
                      <ViewStudent
                        userInfo={viewUser}
                        onClose={setViewVisible}
                        packageInfo={packageInfo}
                        packages={packages}
                      />
                    </ModalBody>
                  </Modal>
                  {selectedbranch.length > 0 && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {/*        <span style={{ color: "white", fontSize: "18px" }}>
                        Branch :
                      </span>{" "} */}
                      <span style={{ color: 'yellowgreen', fontSize: '18px' }}>
                        {selectedbranch}
                      </span>
                      <span
                        style={{
                          color: 'yellowgreen',
                          fontSize: '18px',
                          marginLeft: '8px',
                        }}
                      >
                        {' '}
                        Branch Results Are Showing...
                      </span>
                      <div
                        style={{
                          background: 'orange',
                          color: 'white',
                          paddingLeft: '5px',
                          paddingRight: '5px',
                          borderRadius: '10px',
                          marginLeft: '10px',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          setSelectedBranch('');
                          getUsers();
                          handleClose();
                        }}
                      >
                        <span>clear</span>
                      </div>
                    </div>
                  )}

                  {inCompleteData ? (
                    <Table className='tablesorter'>
                      <thead className='text-primary'>
                        <tr>
                          {currentUser?.modificationAccess == '0' && (
                            <th>
                              <input
                                type='checkbox'
                                checked={allChecked}
                                onChange={(e) => {
                                  let checked = e.target.checked;
                                  if (checked == true) {
                                    setSelected(true);
                                  } else {
                                    setSelected(false);
                                    setSelectedArr([]);
                                  }
                                  let checkedData = userData.map((data) => {
                                    data.select = checked;
                                    return data;
                                  });
                                  setAllChecked(checked);
                                  setUserData(checkedData);
                                }}
                              />
                            </th>
                          )}
                          <th>Student Name</th>
                          <th style={{ textAlign: 'center' }}>ENROLL.No</th>
                          <th style={{ textAlign: 'center' }}>Email</th>
                          <th style={{ textAlign: 'center' }}>Mobile</th>
                          <th style={{ textAlign: 'center' }}>Batch</th>
                          <th style={{ textAlign: 'center' }}>Shift</th>
                          <th style={{ textAlign: 'center' }}>Status</th>
                          <th
                            style={{ textAlign: 'center', minWidth: '100px' }}
                          >
                            Action
                          </th>
                          <th style={{ textAlign: 'center' }}>
                            Study Material
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {userData.map((user, i) => {
                          // console.log("userData:", user);
                          // if (
                          //   user.firstname === undefined &&
                          //   user.lastname === undefined
                          // ) {
                          //   return null;
                          // }
                          return (
                            <tr key={user._uniqueID}>
                              {currentUser?.modificationAccess == '0' && (
                                <td>
                                  <input
                                    type='checkbox'
                                    checked={user.select}
                                    onChange={(e) => {
                                      let checked = e.target.checked;
                                      setUserData(
                                        userData.map((data) => {
                                          if (
                                            user._uniqueID === data._uniqueID
                                          ) {
                                            data.select = checked;
                                            if (checked) {
                                              setSelectedArr((prev) => [
                                                { id: user._uniqueID },
                                                ...prev,
                                              ]);
                                            } else {
                                              setSelectedArr((prev) =>
                                                prev.filter(
                                                  (dataId) =>
                                                    dataId.id !== user._uniqueID
                                                )
                                              );
                                            }
                                          }
                                          if (e.target.checked == false) {
                                            setAllChecked(false);
                                          }
                                          return data;
                                        })
                                      );
                                    }}
                                  />
                                </td>
                              )}
                              <td>
                                {!user.firstname && !user.lastname
                                  ? 'N/A'
                                  : user.firstname + ' ' + user.lastname}
                              </td>
                              <td style={{ textAlign: 'center' }}>
                                {user.enrollmentNO ? user.enrollmentNO : 'N/A'}
                              </td>
                              <td style={{ textAlign: 'center' }}>
                                {user.email || 'N/A'}
                              </td>
                              <td style={{ textAlign: 'center' }}>
                                {user.mobile || 'N/A'}
                              </td>
                              {/* {user.enrollmentNO || user.enrolled ? ( */}
                              <td>
                                <ReactMultiSelectCheckboxes
                                  styles={customStyles}
                                  value={
                                    user.batchName &&
                                    typeof user.batchName == 'object'
                                      ? user.batchName
                                      : ''
                                  }
                                  getDropdownButtonLabel={({
                                    placeholderButtonLabel,
                                    value,
                                  }) => {
                                    if (value && value.length !== 0) {
                                      return `${value?.length} selected`;
                                    } else {
                                      return `Select`;
                                    }
                                  }}
                                  onChange={(option, e) => {
                                    document.querySelector(
                                      '#loading-indicator'
                                    ).style.display = 'flex';
                                    console.log('onchange user is', user);
                                    batchSelect(
                                      e.option.value,
                                      e.action,
                                      user._uniqueID || user.userID,
                                      option
                                    );
                                  }}
                                  options={batchList.map((item) => ({
                                    label: item.batchName,
                                    value: item.itemID,
                                  }))}
                                />
                              </td>
                              {/* ) : (
                              <td style={{ textAlign: 'center' }}>N/A</td>
                            )} */}
                              <td style={{ textAlign: 'center' }}>
                                {user.shift && user.shift !== ''
                                  ? shiftChooser(user.shift)
                                  : !user.shiftUpdatedByAdmin &&
                                    user?.Courses &&
                                    Object.keys(user?.Courses).length !== 0 &&
                                    user?.shiftsSelected &&
                                    Object.keys(user?.shiftsSelected).length !==
                                      0
                                  ? shiftChooser(
                                      user?.shiftsSelected[
                                        Object.keys(user?.shiftsSelected)[0]
                                      ]
                                    )
                                  : 'N/A'}
                              </td>
                              <td style={{ textAlign: 'center' }}>
                                {user.status || 'Active'}
                              </td>
                              <td
                                style={{
                                  textAlign: 'center',
                                  minWidth: '100px',
                                }}
                              >
                                <Edit
                                  onClick={() => {
                                    setEditVisible(true);

                                    setEditUser(user);
                                  }}
                                  style={{
                                    color: '#247cf7',
                                    cursor: 'pointer',
                                  }}
                                />
                                {/* <Modal isOpen={editVisible} style={{ display: 'flex', flex: 1, top: 0 }} size='lg'>
                              <ModalBody style={{
                                width: '100%', display: 'inline-block', padding: '0px !important', position: 'absolute',
                                border: '1px solid white !important',
                              }} size='sm'>
                                <Edit_Student
                                  notify={notify}
                                  userData={editUser}
                                  setUserData={setUserData}
                                  // firstname={editUser!==undefined && editUser.firstname} 
                                  // lastname={editUser!==undefined&& editUser.lastname}
                                  // mobile={editUser!==undefined &&editUser.mobile}
                                  // status={editUser!==undefined &&editUser.status}
                                  // enrollment={editUser!==undefined && editUser.enrollment}
                                  onClick={() => {
                                    setEditVisible(false)
                                  }}
                                >
                                </Edit_Student>
                              </ModalBody>

                            </Modal> */}
                                <VisibilityIcon
                                  style={{
                                    color: '#296ff6',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    setViewVisible(true);
                                    setViewUser(user);
                                  }}
                                />
                                <Delete
                                  style={{ color: 'red', cursor: 'pointer' }}
                                  notify={notify}
                                  onClick={() => {
                                    if (
                                      currentUser?.modificationAccess == '0'
                                    ) {
                                      setDeleteUserVisible(true);
                                      setDeletedUser(user);
                                    } else {
                                      notify(
                                        "You don't have permission to delete any student",
                                        true
                                      );
                                    }
                                  }}
                                />
                                {/* <Modal isOpen={deleteUserVisible} style={{ width: 250 }}>
                              <ModalBody style={{ width: '100%', padding: 0 }} size='sm'>
                                <Delete_modal
                                  notify={notify}
                                  setUserData={setUserData}
                                  uid={deletedUser !== undefined && deletedUser._uniqueID}
                                  onClick={() => {
                                    setDeleteUserVisible(false)
                                  }}
                                ></Delete_modal>
                              </ModalBody>

                            </Modal> */}
                              </td>
                              <td style={{ textAlign: 'center', minWidth: 70 }}>
                                <Button
                                  color='info'
                                  style={{ paddingLeft: 10, paddingRight: 10 }}
                                  onClick={() => {
                                    setcurrentStuId(user._uniqueID);
                                    handlefullToggle();
                                  }}
                                >
                                  <LibraryBooksIcon /> / <QuestionAnswerIcon />
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  ) : (
                    <IncompleteStudents />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}

export default Students_Table;
